import { render } from "./LicensePrompt.vue?vue&type=template&id=0d97626a&scoped=true"
import script from "./LicensePrompt.vue?vue&type=script&lang=ts"
export * from "./LicensePrompt.vue?vue&type=script&lang=ts"

import "./LicensePrompt.vue?vue&type=style&index=0&id=0d97626a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d97626a"

export default script